__turbopack_context__.v({
  "container": "serp-module-scss-module___LIl9W__container",
  "research-title": "serp-module-scss-module___LIl9W__research-title",
});
